import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method apiLogin
 * @method apiLogout
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    apiLogin: function(username, password, strUUID, strDeviceToken, strClientVersion, isDeviceNotiEnable) {
        var params = {
            username: username,
            password: password,
            uuid: strUUID,
            app_id: this.config().app_id,
            os: "web",
            platform: "web",
            mac_address: strUUID,
            device_noti_enable: isDeviceNotiEnable,
            client_version: strClientVersion,
            device_token: strDeviceToken,
        };

        var url = this.config().bzbs_url + "/auth/bzbs_login";
        return BzbsApi.connectBzbsPost(url, null, params);
    },

    apiLogout: function(strBzbsToken, strFBToken, strUUID) {
        var params = {
            uuid: strUUID,
            access_token: strFBToken,
        };

        var url = this.config().bzbs_url + "/auth/logout";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params);
    }
}
